// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"241":"18b6fd17","455":"34b911ba","611":"e36f9e3e","707":"c976a044","843":"085c4535","888":"c866f27e","977":"e0f6af88"}[chunkId] + ".chunk.js";
};